import React from 'react';
import { shallowEqual } from 'react-redux';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { InnerRender } from './InnerRender';
import { useResponsiveTable } from '../store';

const NoMemoAdditional = ({ tableName }: { tableName?: string }) => {
  const { name } = useResponsiveTableContext(tableName);

  const additionalFilters = useResponsiveTable((global) => {
    const state = global.responsiveTableSlice[name];
    return state?.filters.filter(
      (current) =>
        !current.group &&
        ((!current.isMeta &&
          !state?.columns.find(
            (search) => search.name === current.column && !current.asAdditional,
          )) ||
          state?.columns.find(
            (search) =>
              search.name === current.column && search.showAsAdditional,
          ) ||
          current.asAdditional),
    );
  }, shallowEqual);

  return <InnerRender tableName={tableName} filters={additionalFilters} />;
};

export const Additional = React.memo(NoMemoAdditional);
